const CARD_METHOD = 'Cartão'
const BILLET_METHOD = 'Boleto'

const NOT_PAID_STATUS = 'NOT_PAID'
const WAITING_PAYMENT_STATUS = 'WAITING_PAYMENT'
const WAITING_CONFIRM_STATUS = 'WAITING_CONFIRM'
const PAID_STATUS = 'PAID'
const CANCELED_STATUS = 'CANCELED'
const FAILURE_STATUS = 'FAILURE'
const OVERDUE_STATUS = 'OVERDUE'
const INTEGRATION_STATUS = 'INTEGRATION'
const PRE_CAPTURED_STATUS = 'PRE_CAPTURED'
const LOSS_STATUS = 'LOSS'
const WAITING_GATEWAY_STATUS = 'WAITING_GATEWAY'
const WAITING_NFE_STATUS = 'WAITING_NFE'
const WAITING_WITHDRAW_STATUS = 'WAITING_WITHDRAW'
const GRATUITY_STATUS = 'GRATUITY'
const LINK_PAYMENT_STATUS = 'LINK_PAYMENT'

const NOT_PAID_LABEL = 'NÃO PAGO'
const WAITING_PAYMENT_LABEL = 'AGUARDANDO PAGAMENTO'
const WAITING_CONFIRM_LABEL = 'AGUARDANDO CONFIRMAÇÃO'
const PAID_LABEL = 'PAGO'
const CANCELED_LABEL = 'CANCELADO'
const FAILURE_LABEL = 'FALHA'
const OVERDUE_LABEL = 'VENCIDO'
const INTEGRATION_LABEL = 'INTEGRAÇÃO'
const LOSS_LABEL = 'PERDA'
const WAITING_GATEWAY_LABEL = 'AGUARDANDO GATEWAY'
const WAITING_NFE_LABEL = 'AGUARDANDO NOTA FISCAL'
const WAITING_WITHDRAW_LABEL = 'AGUARDANDO SAQUE'
const GRATUITY_LABEL = 'GRATUIDADE'
const PRE_CAPTURED_LABEL = 'EM ANÁLISE'
const LINK_PAYMENT_LABEL = 'LINK DE PAGAMENTO'

const STATUS_NFE = {
  '001': 'Aguardando envio para a prefeitura.',
  '002': 'Enviado para a prefeitura, aguardando processamento.',
  '003': 'Processado com erro.',
  '004': 'Processado com sucesso.',
  '005': 'Cancelado com sucesso.',
}

const STEPS_LISTS = [
  {
    id: 'init_payment',
    name: 'Ordem de pagamento criada.',
  },
  {
    id: 'notify_gateway',
    name: 'Enviado os dados para o gateway de pagamento.',
  },
  {
    id: 'factored',
    name: 'Faturado no OMIE.',
  },
  {
    id: 'issued_nfe',
    name: 'Nota fiscal solicitada.',
  },
  {
    id: 'nfe_available',
    name: 'Nota fiscal disponível.',
  },
  {
    id: 'send_charge_client',
    name: 'Cobrança enviada para cliente.',
  },
  {
    id: 'nfe_sent',
    name: 'Nota fiscal enviada para o cliente.',
  },
  {
    id: 'confirmation_receivable_omie',
    name: 'baixa em conta a receber.',
  },
  {
    id: 'payment_confirmation_sent_client',
    name: 'Confirmação do pagamento enviada para o cliente.',
  },
]

const STATUSES = {
  CANCELED_STATUS,
  FAILURE_STATUS,
  NOT_PAID_STATUS,
  OVERDUE_STATUS,
  PAID_STATUS,
  WAITING_CONFIRM_STATUS,
  WAITING_PAYMENT_STATUS,
  INTEGRATION_STATUS,
  PRE_CAPTURED_STATUS,
  LOSS_STATUS,
  WAITING_NFE_STATUS,
  WAITING_GATEWAY_STATUS,
  WAITING_WITHDRAW_STATUS,
  GRATUITY_STATUS,
  LINK_PAYMENT_STATUS,
}

const STATUSES_LABELS = {
  CANCELED_LABEL,
  FAILURE_LABEL,
  NOT_PAID_LABEL,
  OVERDUE_LABEL,
  PAID_LABEL,
  WAITING_CONFIRM_LABEL,
  WAITING_PAYMENT_LABEL,
  INTEGRATION_LABEL,
  LOSS_LABEL,
  WAITING_NFE_LABEL,
  WAITING_GATEWAY_LABEL,
  WAITING_WITHDRAW_LABEL,
  GRATUITY_LABEL,
  PRE_CAPTURED_LABEL,
  LINK_PAYMENT_LABEL,
}

const TYPE_BILLING_DAY_DYNAMIC = 'dynamic'
const TYPE_BILLING_DAY_FIXED = 'fixed'

const PAYMENT_METHODS = [
  {
    id: 'Transferência bancaria',
    name: 'Transferência bancaria',
  },
  { id: 'Boleto', name: 'Boleto' },
  { id: 'Cartão', name: 'Cartão' },
  { id: 'Pix', name: 'Pix' },
]

const GATEWAYES = [
  { id: 'omie', name: 'OMIE' },
  { id: 'superfin', name: 'Superfin' },
]

const STATUS_OPTIONS = [
  {
    id: NOT_PAID_STATUS,
    name: NOT_PAID_LABEL,
  },
  { id: WAITING_PAYMENT_STATUS, name: WAITING_PAYMENT_LABEL },
  { id: WAITING_CONFIRM_STATUS, name: WAITING_CONFIRM_LABEL },
  { id: PAID_STATUS, name: PAID_LABEL },
  { id: CANCELED_STATUS, name: CANCELED_LABEL },
  { id: FAILURE_STATUS, name: FAILURE_LABEL },
  { id: OVERDUE_STATUS, name: OVERDUE_LABEL },
  { id: INTEGRATION_STATUS, name: INTEGRATION_LABEL },
  { id: LOSS_STATUS, name: LOSS_LABEL },
  { id: WAITING_NFE_STATUS, name: WAITING_NFE_LABEL },
  { id: WAITING_GATEWAY_STATUS, name: WAITING_GATEWAY_LABEL },
  { id: WAITING_WITHDRAW_STATUS, name: WAITING_WITHDRAW_LABEL },
  { id: GRATUITY_STATUS, name: GRATUITY_LABEL },
  { id: PRE_CAPTURED_STATUS, name: PRE_CAPTURED_LABEL },
]

const CANCEL_MESSAGE = {
  omie:
    'Essa ação somente troca o status da ordem de pagamento para ' +
    'cancelado, a execução no OMIE depende da seleção abaixo.',
  superfin:
    'Essa ação vai mudar o status da ordem de pagamento para cancelado e ' +
    'sera solicitado o cancelamento na Superfin, a execução no OMIE depende ' +
    'da seleção abaixo.',
}

const DESCRIPTION_ORDERS_OVERDUE = {
  TOMORROW: 'Pagamentos a vencer',
  TODAY: 'Pagamentos em atraso',
  YESTERDAY: 'Pagamentos em atraso',
}

const DESCRIPTION_PAID_CLIENT =
  'Essa é a data em que o cliente efetuou o pagamento da ordem, que pode não ' +
  'coincidir com a data de confirmação do pagamento feita pelo ' +
  'intermediador. No caso de boletos, essa confirmação pode levar até 3 dias' +
  'úteis, dependendo da compensação bancária.'

const DESCRIPTION_PAID_GATEWAY =
  'Essa é a data em que o intermediador de pagamento nos confirmou o ' +
  'pagamento da ordem, lembrando que o cliente pode ter pago antes, ' +
  'mas a confirmação pode levar até 3 dias úteis, dependendo da compensação ' +
  'bancária.'

const DESCRIPTION_EXPIRATION =
  'Dependendo do método de pagamento, o vencimento pode ter utilidades ' +
  'diferentes.'

const DESCRIPTION_CREDIT =
  'Essa é a data em que o valor, já descontado, estará disponível para saque.'

const paymentOrder = {
  CARD_METHOD,
  BILLET_METHOD,
  STATUSES,
  STATUSES_LABELS,
  STATUS_NFE,
  STEPS_LISTS,
  TYPE_BILLING_DAY_DYNAMIC,
  TYPE_BILLING_DAY_FIXED,
  PAYMENT_METHODS,
  GATEWAYES,
  STATUS_OPTIONS,
  CANCEL_MESSAGE,
  DESCRIPTION_ORDERS_OVERDUE,
  DESCRIPTION_PAID_CLIENT,
  DESCRIPTION_PAID_GATEWAY,
  DESCRIPTION_EXPIRATION,
  DESCRIPTION_CREDIT,
}

export default paymentOrder
